import React from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import useMediaQuery from "@mui/material/useMediaQuery";
import Hidden from "@mui/material/Hidden";
import Button from "@mui/material/Button";
import history from "../../assets/history.svg";
import yearbook from "../../assets/yearbook.svg";
import Constitution from "../../assets/Constitution.png";

import CallToAction from "../ui/CallToAction";

const useStyles = makeStyles((theme) => ({
  missionStatement: {
    fontStyle: "italic",
    fontWeight: 300,
    fontSize: "1.5rem",
    maxWidth: "50em",
    lineHeight: 1.4,
  },
  rowContainer: {
    paddingLeft: "5em",
    paddingRight: "5em",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "1.5em",
      paddingRight: "1.5em",
    },
  },
  avatar: {
    height: "25em",
    width: "25em",
    [theme.breakpoints.down("md")]: {
      height: "20em",
      width: "20em",
      maxHeight: 300,
      maxWidth: 300,
    },
  },
}));

export default function About(props) {
  const classes = useStyles();
  const theme = useTheme();
  const matchesMD = useMediaQuery(theme.breakpoints.down("lg"));

  const onButtonClick = () => {
    fetch("Pivot-Club.pdf").then((response) => {
      response.blob().then((blob) => {
        // Creating new object  of PDF File
        const fileURL = window.URL.createObjectURL(blob);
        // Setting the file name
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.download = "Pivot-Club.pdf";
        fileLink.click();
      });
    });
  };

  return (
    <Grid container direction="column">
      <Grid
        item
        className={classes.rowContainer}
        style={{ marginTop: matchesMD ? "1em" : "2em" }}
      >
        <Typography align={matchesMD ? "center" : "center"} variant="h2">
          About Us
        </Typography>
      </Grid>
      <Grid
        item
        container
        justifyContent="center"
        className={classes.rowContainer}
        style={{ marginTop: "3em" }}
      >
        <Typography
          variant="h4"
          align="center"
          className={classes.missionStatement}
        >
          "We are here to make great impact in the field of Engineering and
          Tech. We use engineering concepts learnt in class with a touch of
          cutting edge technologies to generate solutions to problems withing
          our society!"
        </Typography>
      </Grid>
      <Grid
        item
        container
        className={classes.rowContainer}
        style={{ marginTop: "10em", marginBottom: "10em" }}
        direction={matchesMD ? "column" : "row"}
        alignItems={matchesMD ? "center" : undefined}
        justifyContent="space-between"
      >
        <Grid item>
          <Grid
            item
            container
            direction="column"
            lg
            style={{ maxWidth: "35em" }}
          >
            <Grid item>
              <Typography
                align={matchesMD ? "center" : undefined}
                variant="h4"
                gutterBottom
              >
                History
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="body1"
                align={matchesMD ? "center" : undefined}
                paragraph
                style={{ fontWeight: 700, fontStyle: "italic" }}
              >
                We've been around for 7 years now
              </Typography>
              <Typography
                variant="body1"
                align={matchesMD ? "center" : undefined}
                paragraph
              >
                Founded in 2015 by Eng Erick Rangili and Martin Wadende as KURET
              </Typography>
              <Typography
                variant="body1"
                align={matchesMD ? "center" : undefined}
                paragraph
              >
                Ever since it's inception, the club has been involved in various
                projects and activities that have helped the community and the
                students.
              </Typography>
              <Typography
                variant="body1"
                align={matchesMD ? "center" : undefined}
                paragraph
              >
                Our predecessors are grateful for being part and parcel of Pivot
                Club Kenyatta University since it has really impacted their
                lives positively!
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid item container justifyContent="center" lg>
            <img
              src={history}
              alt="quill pen sitting on top of book"
              style={{ maxHeight: matchesMD ? 200 : "22em" }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        container
        className={classes.rowContainer}
        style={{ marginTop: "10em", marginBottom: "10em" }}
        direction={matchesMD ? "column" : "row"}
        alignItems={matchesMD ? "center" : undefined}
        justifyContent="space-between"
      >
        <Grid item>
          <Grid
            item
            container
            direction="column"
            lg
            style={{ maxWidth: "35em" }}
          >
            <Grid item>
              <Typography
                align={matchesMD ? "center" : undefined}
                variant="h4"
                gutterBottom
              >
                Our Constitution
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="body1"
                align={matchesMD ? "center" : undefined}
                paragraph
                style={{ fontWeight: 700, fontStyle: "italic" }}
              ></Typography>
              <Typography
                variant="body1"
                align={matchesMD ? "center" : undefined}
                paragraph
              >
                Constitution guides us on how to conduct ourselves as club
                members.
              </Typography>
              <Typography
                variant="body1"
                align={matchesMD ? "center" : undefined}
                paragraph
              >
                As the adage by the sages, "When you go to the romans behave
                like the romans!" We strongly advocate you adhere by the rules
                and regulations stipulated in our Constitution.
              </Typography>
              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={onButtonClick}
                style={{ alignItem: "center", marginLeft: "10em" }}
              >
                Download Constitution
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid item container justifyContent="center" lg>
            <img
              src={Constitution}
              alt="quill pen sitting on top of book"
              style={{ maxHeight: matchesMD ? 200 : "22em" }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        container
        direction="column"
        alignItems="center"
        className={classes.rowContainer}
        style={{ marginBottom: "15em" }}
      >
        <Grid item>
          <Typography align="center" variant="h4" gutterBottom>
            Our Executive Team
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Club Chairperson
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Tony Maiyo
          </Typography>
        </Grid>
        <Grid item>
          <Avatar alt="chairman" src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662555630/Pivot%20Club/Maiyo_va0cnu.jpg" className={classes.avatar} />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Electrical and Electronics Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                He oversees the overall activities of the club. Together with
                executive council he ensures club activities are handled
                accordingly.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Leadership has really impacted his life positively!"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Vice Chairperson
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Peter Kagwe
          </Typography>
        </Grid>
        <Grid item>
          <Avatar alt="vice-chairperson" src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662557159/Pivot%20Club/Kagwe_uej92n.jpg" className={classes.avatar} />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Electrical and Electronics Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                He works closely with the Chairperson.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Being a leader has really moulded me into a responsible
                individual"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Project Lead
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Ian Njenga
          </Typography>
        </Grid>
        <Grid item>
          <Avatar alt="project-lead" src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662554798/Pivot%20Club/Iano_ilix84.jpg" className={classes.avatar} />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Civil Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Responsible for the overall project management of the club.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Being a leader has really moulded me into a responsible
                individual"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Industrial Lead
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Shirlyn Mugambi
          </Typography>
        </Grid>
        <Grid item>
          <Avatar alt="Industrial Lead" src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662554798/Pivot%20Club/Shirlyn_ry7kod.jpg" className={classes.avatar} />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Petroleum Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Responsible for the overall industrial relations of the club.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Being a leader has really moulded me into a responsible
                individual"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Treasurer
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Shadrack Kipkirui
          </Typography>
        </Grid>
        <Grid item>
          <Avatar alt="Treasurer" src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662557174/Pivot%20Club/Shadrack_zuwb5j.jpg" className={classes.avatar} />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Civil Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Responsible for the overall financial management of the club.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Being a leader has really moulded me into a responsible
                individual"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Secretary
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Susan Waweru
          </Typography>
        </Grid>
        <Grid item>
          <Avatar alt="Secretary" src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662554795/Pivot%20Club/Susan_s3dpzp.jpg" className={classes.avatar} />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Civil Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Responsible for the overall administrative management of the
                club.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Being a leader has really moulded me into a responsible
                individual"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Assistant Project Lead
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Kennedy Odeyo
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            alt="Assistant-Project-Lead"
            src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662554796/Pivot%20Club/Kenna_edvtzm.jpg"
            className={classes.avatar}
          />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Electrical and Electronics Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Responsible for the overall project management of the club.
                Works closely with the Project Lead.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Being a leader has really moulded me into a responsible
                individual"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Publicity Team Lead
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Ronnie Ochieng
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            alt="Publicity-team-lead"
            src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662534296/Pivot%20Club/Ronnie_vu0twh.jpg"
            className={classes.avatar}
          />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Biomedical Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Responsible for the overall publicity management of the club.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Being a leader has really moulded me into a responsible
                individual"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Product Design Team Lead
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Abigael Mutinda
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            alt="Product-Design-Team-Lead"
            src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662554798/Pivot%20Club/Abbie_ruigme.jpg"
            className={classes.avatar}
          />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Civil Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Responsible for the overall product design management of the
                club.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Being a leader has really moulded me into a responsible
                individual"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Assistant Product Design Team Lead
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Gideon Muratha
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            alt="Assistant-Product-Design-Team-Lead"
            src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662554797/Pivot%20Club/Gideon_oia3hr.jpg"
            className={classes.avatar}
          />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Civil Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Responsible for the overall product design management of the
                club. Works closely with the Product Design Team Lead.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Being a leader has really moulded me into a responsible
                individual"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
        <Grid item>
          <Typography variant="body1" paragraph align="center">
            Assistant Publicity Team Lead
          </Typography>
          <Typography variant="body1" paragraph align="center">
            Gloria Mbumba
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            alt="Assistant-Publicity-Team-Lead"
            src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662554797/Pivot%20Club/Mbumba_orii3e.jpg"
            className={classes.avatar}
          />
        </Grid>
        <Grid item container justifyContent={matchesMD ? "center" : undefined}>
          <Hidden lgUp>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Electrical and Electronics Engineering Student
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                Responsible for the overall publicity management of the club.
                Works closely with the Publicity Team Lead.
              </Typography>
            </Grid>
          </Hidden>
          <Hidden lgDown>
            <Grid item lg style={{ maxWidth: "45em", padding: "1.25em" }}>
              <Typography variant="body1" align="center" paragraph>
                Testimonials
              </Typography>
              <Typography variant="body1" align="center" paragraph>
                "Being a leader has really moulded me into a responsible
                individual"
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
      </Grid>
      <Grid item>
        <CallToAction setValue={props.setValue} />
      </Grid>
    </Grid>
  );
}
